// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productPrice":"productPrice_Gv3sc","productDiscountLabel":"productDiscountLabel_BoRZr"};